import { Component, Input, OnInit } from '@angular/core';
import { FieldV2Dto } from 'src/app/api/exa';
import { FieldService } from 'src/app/services/field.service';
import { MarkerTypeEnum } from '../../../enums/marker-type-enum';

@Component({
  selector: 'drawer-content-field-info',
  templateUrl: './field-info.component.html',
  styleUrls: ['./field-info.component.scss'],
})
export class FieldInfoComponent implements OnInit {
  @Input('field') field: FieldV2Dto;

  fieldLatitude = null;
  fieldLongitude = null;

  googleMapsUrl: string;
  poiLat: any;
  poiLng: any;

  constructor(private fieldService: FieldService) {}

  ngOnInit() {}

  onFieldClick(field) {
    this.fieldLatitude = field.geometry.centroid.latitude;
    this.fieldLongitude = field.geometry.centroid.longitude;

    const fieldNav = this.fieldService.getFieldById(field.id).geometry.pois;

    if (fieldNav == null) {
    } else if (fieldNav) {
      fieldNav.forEach((el) => {
        if (el.type == MarkerTypeEnum.ENTRANCE) {
          this.poiLat = el.coordinate.latitude;
          this.poiLng = el.coordinate.longitude;
        }
      });
    }
  }

  navigateToField() {
    this.onFieldClick(this.field);

    const poiLat = this.poiLat;
    const poiLng = this.poiLng;

    if (poiLat && poiLng) {
      this.googleMapsUrl = encodeURI(`https://www.google.com/maps/dir/?api=1&destination=${poiLat}+${poiLng}&travelmode=driving`);
      this.poiLat = null;
      this.poiLng = null;
    } else {
      this.googleMapsUrl = encodeURI(
        `https://www.google.com/maps/dir/?api=1&destination=${this.fieldLatitude}+${this.fieldLongitude}&travelmode=driving`
      );
    }
    window.open(encodeURI(this.googleMapsUrl), '_system');
  }
}
